import React from "react";

export const Theology = ({size = 20, ...props}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 512 512"
            {...props}
        >
            <path
                fill="#fff5f5"
                d="M116 395c-22.091 0-40 17.909-40 40s17.909 40 40 40h315v-80z"
            ></path>
            <path fill="#e2dff4" d="M293.5 395H431v80H293.5z"></path>
            <path
                fill="#ffd422"
                d="M116 0C85.624 0 61 24.624 61 55v380l38-40h52V15c0-8.284-6.716-15-15-15z"
            ></path>
            <path
                fill="#616173"
                d="M451 15c0-8.284-6.716-15-15-15H136v395h315z"
            ></path>
            <path
                fill="#403b40"
                d="M451 15c0-8.284-6.716-15-15-15H293.5v395H451z"
            ></path>
            <path fill="#ffd422" d="M203.5 70h180v240h-180z"></path>
            <path fill="#ff9f22" d="M293.5 70h90v240h-90z"></path>
            <path
                fill="#8989a5"
                d="M451 395v-15H116c-30.376 0-55 24.624-55 55s24.624 55 55 55h320c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15H116c-13.807 0-25-11.193-25-25s11.193-25 25-25h102.5l37.5 11 37.5-11H436c8.284 0 15-6.716 15-15z"
            ></path>
            <path
                fill="#616173"
                d="M436 490c8.284 0 15-6.716 15-15s-6.716-15-15-15H293.5v30zM436 410c8.284 0 15-6.716 15-15v-15H293.5v30z"
            ></path>
            <path
                fill="#ffd422"
                d="M277.253 509.79L256 492.787l-21.253 17.002c-6.548 5.238-16.247.576-16.247-7.809V410h75v91.981c0 8.385-9.699 13.047-16.247 7.809z"
            ></path>
            <path
                fill="#ffeb99"
                d="M323.5 155h-15v-25c0-8.284-6.716-15-15-15s-15 6.716-15 15v25h-15c-8.284 0-15 6.716-15 15s6.716 15 15 15h15v65c0 8.284 6.716 15 15 15s15-6.716 15-15v-65h15c8.284 0 15-6.716 15-15s-6.716-15-15-15z"
            ></path>
            <path
                fill="#ffd422"
                d="M308.5 250v-65h15c8.284 0 15-6.716 15-15s-6.716-15-15-15h-15v-25c0-8.284-6.716-15-15-15v150c8.284 0 15-6.716 15-15z"
            ></path>
            <path
                fill="#ffeb99"
                d="M383.5 325h-180c-8.284 0-15-6.716-15-15V70c0-8.284 6.716-15 15-15h180c8.284 0 15 6.716 15 15v240c0 8.284-6.716 15-15 15zm-165-30h150V85h-150z"
            ></path>
            <path
                fill="#ffd422"
                d="M398.5 310V70c0-8.284-6.716-15-15-15h-90v30h75v210h-75v30h90c8.284 0 15-6.716 15-15z"
            ></path>
        </svg>
    );
}

export default Theology;